import React, { useRef } from "react";
import { Button, Paper, Avatar, Typography, Box  } from "@mui/material";
import { styled } from "@mui/system";
import { useSelector } from "src/redux/store";

const StyledPaper = styled(Paper)((props) => ({
  padding: "10px",
  margin: "8px 0",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  borderRadius: "8px",
  cursor: "pointer",
}));

export default function ButtonComponent(props) {
  const {
    width,
    iconImageUrl,
    onClick,
    captionText,
    subscript,
    elevation,
    border,
    underline,
    iconWidth,
    iconHeight,
    hoverIconImageUrl,
    showBorderOnClick,
    titleText,
    backgroundColorBatchEditor,
    btnStyle,
  } = props;

  const paperRef = useRef(null);
  const fileUpload = useSelector((state) => state.fileUpload);
  const [hover, setHover] = React.useState(false);

  const handleMouseOver = () => {
    setHover(true);
  };

  const handleMouseLeave = () => {
    setHover(false);
  };

  React.useEffect(() => {
    if (fileUpload.showDialog && showBorderOnClick) {
      paperRef.current.style.border = "1px solid #262626";
    } else if (!border) {
      paperRef.current.style.border = "";
    }
  }, [fileUpload.showDialog]);

  return (
    <StyledPaper
      onClick={onClick}
      ref={paperRef}
      onMouseOver={handleMouseOver}
      onMouseLeave={handleMouseLeave}
      hoverIconImageUrl
      sx={{
        width: width,
        m:0,
        border: border ? "1px dashed #EEEEEE" : "",
        backgroundColor:backgroundColorBatchEditor? "rgba(240, 55, 80, 1)": " ",
        "&:hover": {
          backgroundColor:( hoverIconImageUrl || backgroundColorBatchEditor) ? "#262626" : "#fff",
          "& .MuiTypography-root": {
            color: ( hoverIconImageUrl || backgroundColorBatchEditor) ? "white" : "inherit",
          },
        },
      }}
      elevation={elevation}
      style={btnStyle}
    >
      <Box display={"flex"} alignItems={"center"} gap="12px">
        <Avatar
        src={hover ? hoverIconImageUrl || iconImageUrl : iconImageUrl}
        alt="upload icon"
        sx={{ width: iconWidth, height: iconHeight}}
      />
      {titleText && (
        <Typography
        variant="overline"
        align="center"
        sx={{ fontWeight: 400, textTransform: "none", fontSize:"12px"}}
        color="rgba(38, 38, 38, 0.7)"
      >
        {titleText}
      </Typography>
      )}
      </Box>
      {captionText && (
        <Typography
          variant="caption"
          align="center"
          sx={{
            textDecoration: underline ? "underline" : "",
            pt:"8px",
            color:backgroundColorBatchEditor ? "white":"rgba(38, 38, 38, 0.7)",
          }}
        >
          {captionText}
        </Typography>
      )}
      {subscript && (
        <Typography
          variant="overline"
          align="center"
          sx={{ fontWeight: 400, textTransform: "none", paddingTop: "8px" }}
          color="rgba(38, 38, 38, 0.7)"
        >
          {subscript}
        </Typography>
      )}
    </StyledPaper>
  );
}

ButtonComponent.defaultProps = {
  iconImageUrl: "",
  onClick: () => {},
  captionText: "",
  width: "auto",
  subscript: "",
  elevation: 0,
  border: false,
  underline: false,
  hoverIconImageUrl: "",
  iconWidth: "20px",
  iconHeight: "20px",
  showBorderOnClick: false,
};
